import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        backgroundColor: theme.palette.emteria.background.paperDeep,
        padding: theme.spacing(6),
        borderRadius: 1,
        overflow: "auto",
        fontFamily: "monospace",
        fontSize: 16,
    },
    tabPanels: {
        marginTop: theme.spacing(3),
    },
    tabPanel: {
        padding: 0,
    },
    sectionSpacing: {
        marginBottom: theme.spacing(3),
    },
    placeholder: {
        fontSize: 16,
        color: theme.palette.emteria.text.secondary,
    },
    label: {
        width: 150,
        textAlign: "right",
        marginRight: theme.spacing(4),
    },
    hintText: {
        fontSize: 12,
    },
    variantBox: { display: "flex", flexDirection: "column", width: "100%" },
    variantSelectBox: { display: "flex", gap: theme.spacing(1) },
}));
